import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { Separator } from '@doltech/ui/lib/figma/Layout/Landing/Content/Separator';
import { deviceBreakpoints } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import { OutlineParagraphEditor } from '@doltech/ui/lib/shared/components/IELTSample/Outline/OutlineParagraphEditor';
import { OutlineStatementEditor } from '@doltech/ui/lib/shared/components/IELTSample/Outline/OutlineStatementEditor';
import * as React from 'react';
import styled from 'styled-components';

import { getInitialOutlineParagraph, getInitialOutlineStatement } from '../../sample.utils';

const Main = styled.div`
  background-color: ${colorsV2.gray5};
  padding: 16px;
  display: grid;
  gap: 24px;
  .outline-paragraph-idea-list-item-element {
    color: ${colorsV2.black60};
  }

  @media ${deviceBreakpoints.fromTablet} {
    padding: 24px;
  }
`;

export const OutlinePreview = ({ detailData, withOutlineParagraphSeparator = true }) => {
  const [statementNode, paragraphNodes] = React.useMemo(() => {
    return [getInitialOutlineStatement(detailData), getInitialOutlineParagraph(detailData)];
  }, [detailData]);
  const isStatementEmpty = React.useMemo(
    () => Boolean(statementNode?.content?.[0]?.children?.[0]?.text) === false,
    [statementNode.content]
  );
  return (
    <Main className="outline-preview">
      {!isStatementEmpty && (
        <OutlineStatementEditor isReadOnly initialValue={statementNode.content} />
      )}
      {paragraphNodes.map((paragraphNode, paragraphNodeIndex, arr) => {
        const { id, content } = paragraphNode;
        return (
          <React.Fragment key={id}>
            <OutlineParagraphEditor isReadOnly initialValue={content} />
            {withOutlineParagraphSeparator && paragraphNodeIndex < arr.length - 1 && (
              <Separator variant="horizontal" height={4} backgroundColor="black10" />
            )}
          </React.Fragment>
        );
      })}
    </Main>
  );
};
